import AppError from '../errors/AppError';
import IHubSpotPipelineStage from '../interfaces/IHubSpotPipelineStage';
import { IPaginationReturn } from '../interfaces/IPaginationReturn';

import { useRequest } from './useRequest';

const useHubSpotPipelineStageService = () => {
  const request = useRequest<IHubSpotPipelineStage>();
  const path = 'hubspot-pipeline-stages';

  const findAllHubSpotPipelineStages = async (
    hubspotPipelineId: string,
    queryParams: string,
  ): Promise<IPaginationReturn<IHubSpotPipelineStage[]>> => {
    return await request
      .getManyPaginated({ path: `${path}/all/${hubspotPipelineId}?${queryParams}`, sendAuthorization: true })
      .then(result => result)
      .catch(error => {
        throw new AppError(error.message, error.status);
      });
  };

  const createHubSpotPipelineStage = async (stage: IHubSpotPipelineStage): Promise<IHubSpotPipelineStage> => {
    return await request
      .post({ path: `${path}`, sendAuthorization: true, body: stage })
      .then(result => result)
      .catch(error => {
        throw new AppError(error.message, error.status);
      });
  };

  const updateHubSpotPipelineStage = async (
    id: string,
    stage: IHubSpotPipelineStage,
  ): Promise<IHubSpotPipelineStage> => {
    return await request
      .put({ path: `${path}/${id}`, sendAuthorization: true, body: stage })
      .then(result => result)
      .catch(error => {
        throw new AppError(error.message, error.status);
      });
  };

  const deleteHubSpotPipelineStage = async (id: string): Promise<void> => {
    return await request
      .remove({ path: `${path}/${id}`, sendAuthorization: true })
      .then(() => undefined)
      .catch(error => {
        throw new AppError(error.message, error.status);
      });
  };

  const findHubSpotPipelineStage = async (id: string): Promise<IHubSpotPipelineStage> => {
    return await request
      .getOne({ path: `${path}/${id}`, sendAuthorization: true })
      .then(result => result)
      .catch(error => {
        throw new AppError(error.message, error.status);
      });
  };

  return {
    findAllHubSpotPipelineStages,
    updateHubSpotPipelineStage,
    findHubSpotPipelineStage,
    createHubSpotPipelineStage,
    deleteHubSpotPipelineStage,
  };
};

export { useHubSpotPipelineStageService };
